import { getLocale } from "../runtime";

const da_whereareyoushoppingfrom = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hvor handler du fra?`
};

const en_whereareyoushoppingfrom = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Where are you shopping from?`
};

const es_whereareyoushoppingfrom = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `¿Desde dónde compras?`
};

const fi_whereareyoushoppingfrom = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Mistä ostat?`
};

const nb_whereareyoushoppingfrom = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hvor handler du fra?`
};

const sv_whereareyoushoppingfrom = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Var handlar du från?`
};

const whereareyoushoppingfrom = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_whereareyoushoppingfrom(inputs)
	if (locale === "en") return en_whereareyoushoppingfrom(inputs)
	if (locale === "es") return es_whereareyoushoppingfrom(inputs)
	if (locale === "fi") return fi_whereareyoushoppingfrom(inputs)
	if (locale === "nb") return nb_whereareyoushoppingfrom(inputs)
	if (locale === "sv") return sv_whereareyoushoppingfrom(inputs)
	return "whereAreYouShoppingFrom";
};

export { whereareyoushoppingfrom as "whereAreYouShoppingFrom" };